import { CHATBOT_DIMENSIONS } from '../constant';

export const calculateDefaultPosition = (triggerButton?: HTMLButtonElement): { x: number; y: number } => {
  if (!triggerButton) {
    return {
      x: 0,
      y: 0,
    };
  }
  const { bottom, left } = triggerButton.getBoundingClientRect();

  return {
    x: left - CHATBOT_DIMENSIONS.DEFAULT.width / 2 + triggerButton.offsetWidth / 2,
    y: bottom + 8,
  };
};
